/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Col_FilmcraftInputs */

const en_fc_cmp_col_filmcraft = /** @type {(inputs: Fc_Cmp_Col_FilmcraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FilmCraft`)
};

/**
* | output |
* | --- |
* | "FilmCraft" |
*
* @param {Fc_Cmp_Col_FilmcraftInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_col_filmcraft = /** @type {((inputs?: Fc_Cmp_Col_FilmcraftInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Col_FilmcraftInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_col_filmcraft(inputs)
});
export { fc_cmp_col_filmcraft as "fc.cmp.col.filmcraft" }